import { render } from "./module-app.vue?vue&type=template&id=b1bed932"
import script from "./module-app.vue?vue&type=script&lang=js"
export * from "./module-app.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/module/module-app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1bed932"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1bed932', __exports__)) {
    api.reload('b1bed932', __exports__)
  }
  
  module.hot.accept("./module-app.vue?vue&type=template&id=b1bed932", () => {
    api.rerender('b1bed932', render)
  })

}


export default __exports__